import { Component, computed, contentChildren, input, InputSignal, Signal } from '@angular/core';
import { TableHeaderComponent } from '../table-header/table-header.component';

@Component({
    selector: 'app-table-head',
    templateUrl: './table-head.component.html',
    standalone: true,
    host: {
        class: 'block pt-2 pb-1',
        '[class.sticky]': 'sticky()',
        '[class.top-0]': 'sticky()',
        '[class.z-20]': 'sticky()',
        '[style.background-color]': "sticky() ? 'var(--table-header-bg, var(--base-2))' : null"
    }
})
export class TableHeadComponent {
    public sticky: InputSignal<boolean> = input(false);

    private headers = contentChildren(TableHeaderComponent);
    public gridTemplateColumns: Signal<string> = computed(() => {
        return this.headers()
            .map((header) => `minmax(${header.minWidth()}, ${header.width()})`)
            .join(' ');
    });
}
